module.exports = __webpack_public_path__ + "img/297.2f9f021f.png";